import { api as url } from '.';
import { checkAndHandleAuthError } from './authErrorHandler';

const DeleteRequest = async (uri, token = '') => {
    const response = await fetch(url + uri, {
        method: 'DELETE',
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + token
        }
    });

    const data = await response.json();

    // Check for authentication errors and handle with error preservation
    checkAndHandleAuthError(data);

    return data;
};

export { DeleteRequest };
